import { UserRound } from "lucide-react";

const label = (o) => (o.active === false ? `${o.name} (inactive)` : o.name);

// Compact "who is running this line" chip: first `max` operator names, then "+N".
export function OperatorChips({ operators = [], max = 2, emptyLabel = "No operator", className = "", testid }) {
  const shown = operators.slice(0, max);
  const extra = operators.length - shown.length;
  const text = operators.length ? `${shown.map(label).join(", ")}${extra > 0 ? ` +${extra}` : ""}` : emptyLabel;
  return (
    <span
      className={`inline-flex items-start gap-1 text-[10px] min-w-0 ${operators.length ? "text-slate-600" : "text-slate-400 italic"} ${className}`}
      title={operators.map(label).join(", ") || emptyLabel}
      data-testid={testid}
    >
      <UserRound className="h-3 w-3 shrink-0 mt-[1px]" />
      <span className="whitespace-normal break-words">{text}</span>
    </span>
  );
}
